var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.156 13.7985C8.899 12.2645 12 9.13052 12 6.25452C12 4.66322 11.3679 3.13709 10.2426 2.01188C9.11742 0.886657 7.5913 0.254517 6 0.254517C4.4087 0.254517 2.88258 0.886657 1.75736 2.01188C0.632141 3.13709 2.37122e-08 4.66322 0 6.25452C0 9.13052 3.1 12.2645 4.844 13.7985C5.16211 14.0825 5.5736 14.2394 6 14.2394C6.4264 14.2394 6.83789 14.0825 7.156 13.7985ZM4 6.25452C4 5.72408 4.21071 5.21538 4.58579 4.8403C4.96086 4.46523 5.46957 4.25452 6 4.25452C6.53043 4.25452 7.03914 4.46523 7.41421 4.8403C7.78929 5.21538 8 5.72408 8 6.25452C8 6.78495 7.78929 7.29366 7.41421 7.66873C7.03914 8.0438 6.53043 8.25452 6 8.25452C5.46957 8.25452 4.96086 8.0438 4.58579 7.66873C4.21071 7.29366 4 6.78495 4 6.25452Z",
    fill: "#121214"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.4cd7f87d045121aed82c2c25f7b066a7.svg";
export { ForwardRef as ReactComponent };